module.exports = __webpack_public_path__ + "static/media/works.f7122b03.jpg";